import { setUserBoards } from "../../appRedux/actions/Boards";
import { store } from "../../appRedux/store/Store";

export function hydrateBoards(boards, boardIcons) {
   if (!boards?.length) return;

   const processedBoards = boardIcons
      ? boards.map((board) => ({ ...board, iconLink: boardIcons[board.id] }))
      : boards;

   store.dispatch(setUserBoards(processedBoards));
}
